import { IsNotEmpty, IsOptional, Length } from 'class-validator';
import { FieldOptionInterface } from '../../interfaces';

export class FieldOptionDto implements FieldOptionInterface {
	@IsNotEmpty()
	@Length(1, 100, {message: 'Option is required'})
	text: string;
}
